import { useEffect, useState } from "react";
import axios from "axios";
import { FaInstagram, FaTiktok, FaYoutube } from "react-icons/fa";

export default function LiveWidget(){

    const [live,setLive] = useState(null)

    const getLive = async () => {
    try{
        const res = await axios.get(
            process.env.REACT_APP_BASE_URL + "api/live"
        )
        if(res.data.data && res.data.data.length > 0){
            const data = res.data.data[0]
            if(data.status == 1){
                setLive(data)
            }else{
                setLive(null)
            }
            }else{
                setLive(null)
            }
        }catch(err){
                console.log(err)
        }
    }

    useEffect(()=>{
        getLive()
        const interval = setInterval(()=>{
        getLive()
        },20000)
        return ()=>clearInterval(interval)
        },[])

        if(!live || !live.link){
        return null
    }

return(
    <div className="fixed bottom-[100px] left-6 z-50">

        {/* OUTER PULSE RING */}

        <span className="
            absolute
            -inset-2
            rounded-full
            bg-red-500
            opacity-60
            animate-ping
            pointer-events-none
        "></span>

        <div
            rel="noreferrer"
            className="
            group
            relative
            flex
            items-center
            bg-white
            shadow-2xl
            rounded-full
            overflow-hidden
            transition-all
            duration-300
            hover:w-[380px]
            w-[60px]
            h-[60px]
            "
        >

            <img
                src={process.env.REACT_APP_BASE_URL + '/uploads/images/' + live.image}
                className="
                w-[60px]
                h-[60px]
                object-contain
                rounded-full
                p-4
                border-[3px]
                border-red-600
                shadow-[0_0_20px_rgba(255,0,0,0.8)]
                "
            />

            <div
                className="
                flex
                flex-col
                ml-3
                opacity-0
                group-hover:opacity-100
                transition
                duration-300
                whitespace-nowrap
                "
            >

                <div className="flex flex-row items-center gap-2">

                    <span
                        className="
                        text-xs
                        font-bold
                        text-white
                        bg-red-600
                        px-2
                        py-[2px]
                        rounded
                        animate-pulse
                        "
                    >
                        LIVE
                    </span>
                    <a href={live.link} target="_blank">
                        <span className="flex flex-row justify-center items-center gap-1 text-xs font-semibold p-2 hover:bg-gray-200 hover:rounded-3xl">
                            <FaTiktok></FaTiktok> TikTok
                        </span>
                    </a>
                    <a href={live.instagram} target="_blank">
                        <span className="flex flex-row justify-center items-center gap-1 text-xs font-semibold p-2 hover:bg-gray-200 hover:rounded-3xl">
                            <FaInstagram/> Instagram
                        </span>
                    </a>                    
                    <a href={live.youtube} target="_blank">
                        <span className="flex flex-row justify-center items-center gap-1 text-xs font-semibold p-2 hover:bg-gray-200 hover:rounded-3xl">
                            <FaYoutube/> Youtube
                        </span>
                    </a>
                </div>

            </div>

        </div>

    </div>

    )

}